/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */
import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate, useLocation, Location } from 'react-router-dom';
import { IMenuItem } from '@app/modules/main/menu-sidebar/MenuSidebar';
import { useSelector } from 'react-redux';


const MenuItem = ({ menuItem }: { menuItem: IMenuItem }) => {
  const [isMenuExtended, setIsMenuExtended] = useState(false);
  const [isExpandable, setIsExpandable] = useState(false);
  const [isMainActive, setIsMainActive] = useState(false);
  const [isOneOfChildrenActive, setIsOneOfChildrenActive] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const user = useSelector((state: any) => state.auth.currentUser);

  const toggleMenu = () => {
    setIsMenuExtended(!isMenuExtended);
  };

  const handleMainMenuAction = () => {
    if (isExpandable) {
      toggleMenu();
      return;
    }
    navigate(menuItem.path ? menuItem.path : '/');
  };

  const calculateIsActive = (url: Location) => {
    setIsMainActive(false);
    setIsOneOfChildrenActive(false);
    if (isExpandable && menuItem && menuItem.children) {
      menuItem.children.forEach((item) => {
        if (item.path.split('/')[1] === url.pathname.split('/')[1]) {
          setIsOneOfChildrenActive(true);
          setIsMenuExtended(true);
        }
      });
    } else if (menuItem.path && menuItem.path.split('/')[1] === url.pathname.split('/')[1]) {
      setIsMainActive(true);
    }
  };

  useEffect(() => {
    if (location) {
      calculateIsActive(location);
    }
  }, [location, isExpandable, menuItem]);

  useEffect(() => {
    if (!isMainActive && !isOneOfChildrenActive) {
      setIsMenuExtended(false);
    }
  }, [isMainActive, isOneOfChildrenActive]);

  useEffect(() => {
    setIsExpandable(
      Boolean(menuItem && menuItem.children && menuItem.children.length > 0)
    );
  }, [menuItem]);

  return (
    <>
      <li className={`nav-item${isMenuExtended ? ' menu-open' : ''}`} key={menuItem.name}>
        <a
          className={`nav-link${isMainActive || isOneOfChildrenActive ? ' active' : ''
            }`}
          role="link"
          onClick={handleMainMenuAction}
          style={{ cursor: 'pointer' }}
        >
          <i className={`${menuItem.icon}`} />
          <p>{menuItem.name}</p>
          {isExpandable ? <i className="right fas fa-angle-left" /> : null}
        </a>
        {(isExpandable && menuItem && menuItem.children) && <ul className="nav nav-treeview">
          {isExpandable &&
            menuItem &&
            menuItem.children &&
            menuItem.children.map((item) => (
              <li className="nav-item" key={item.path}>
                <NavLink className="nav-link" target={item.target ? '_blank' : ''} to={`${user.settings.Public_Access_Token ? item.path.replace("<Public_Access_Token>", user.settings.Public_Access_Token) : item.path}`}>
                  <i className={`${item.icon}`} />
                  <p>{item.name}</p>
                </NavLink>
              </li>
            ))}
        </ul>
        }
      </li>
    </>
  );
};

export default MenuItem;
